import React, { useState } from 'react';
import { GoogleMap, InfoWindow, Marker } from '@react-google-maps/api';
import { Container } from 'react-bootstrap';
import { defaultCenterMap, mapStyle, Predio } from '../../../../service/types/types';
import { PredioList } from '../../../common/predios';
import UsuariosCercanosModal from './modals/closestUsers.modal';

export default function PrediosMapTable() {
  const [center, setCenter] = useState(defaultCenterMap);
  const [predios, setPredios] = useState<Predio[]>([]);
  const [selectedPredio, setSelectedPredio] = useState<Predio | null>(null);
  const [hoveredPredio, setHoveredPredio] = useState<Predio | null>(null);

  const handleGo = (predio: Predio) => {
    setCenter({ lat: predio.location.coordinates[1], lng: predio.location.coordinates[0] });
    setSelectedPredio(predio);
  };

  return (
    <Container fluid className="p-0">
      <GoogleMap mapContainerStyle={mapStyle} center={center} zoom={12} >
        {predios.map((predio) => (
          <Marker
            key={predio.id}
            position={{ lat: predio.location.coordinates[1], lng: predio.location.coordinates[0] }}
            icon={{
              url: predio.id === selectedPredio?.id ?
                "/green-dot.png" :
                "/red-dot.png"
              ,
              scaledSize: predio.id === selectedPredio?.id ?
                new window.google.maps.Size(20, 30) :
                new window.google.maps.Size(15, 22)
            }}
            onMouseOver={() => setHoveredPredio(predio)}
            onMouseOut={() => setHoveredPredio(null)} />
        ))}
        {hoveredPredio && (
          <InfoWindow
            position={{
              lat: hoveredPredio.location.coordinates[1],
              lng: hoveredPredio.location.coordinates[0],
            }}
            options={{ pixelOffset: new window.google.maps.Size(0, -30), headerDisabled: true }}>
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>
              {hoveredPredio.name}
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
      <br/>
      {/* Mitad inferior: Tabla */}
      <div style={{ height: '50vh', overflowY: 'auto', padding: '1rem' }}>
        <PredioList
          onLoaded={setPredios}
          onSelect={handleGo}
          selectLabel="Ir"
          renderRowActions={(predio) => <UsuariosCercanosModal predioId={predio.id} />}
        />
      </div>
    </Container>
  );
}
